// Imports
import styled from 'styled-components/macro';


// Styled components
const EmptyStateCell = styled.td`
	background-color: #f9f9f9;
	text-align: left;
	font-style: italic;
`;


// Function component
const EmptyStateRow: React.FC<React.PropsWithChildren> = ({ children }) => (
	<tr>
		<EmptyStateCell colSpan={999}>{children}</EmptyStateCell>
	</tr>
);

export default EmptyStateRow;
